import { PickYourOwnColorStoreState } from "./pickYourOwnColor.t";
import { MutationTree } from "vuex";
import { MutationTypesPickYourOwnColor } from "./types";
import { ISwatch } from "../swatches/swatches.t";

export type MutationPickYourOwnColor<S = PickYourOwnColorStoreState> = {
  [MutationTypesPickYourOwnColor.SET_OPEN_COLOR_PICKER](
    state: PickYourOwnColorStoreState,
    payload: boolean
  ): void;
  [MutationTypesPickYourOwnColor.SET_SWATCHES](
    state: PickYourOwnColorStoreState,
    payload: ISwatch[]
  ): void;
  [MutationTypesPickYourOwnColor.ADD_SWATCH](
    state: PickYourOwnColorStoreState,
    payload: ISwatch
  ): void;
  [MutationTypesPickYourOwnColor.REMOVE_SWATCH](
    state: PickYourOwnColorStoreState,
    payload: ISwatch
  ): void;
  [MutationTypesPickYourOwnColor.SET_IS_REMOVING](
    state: PickYourOwnColorStoreState,
    payload: boolean
  ): void;
};

export const mutations: MutationTree<PickYourOwnColorStoreState> &
  MutationPickYourOwnColor = {
  [MutationTypesPickYourOwnColor.SET_OPEN_COLOR_PICKER](state, payload) {
    state.isOpen = payload;
  },
  [MutationTypesPickYourOwnColor.SET_SWATCHES](state, payload) {
    state.swatches = [ ...payload ];
  },
  [MutationTypesPickYourOwnColor.ADD_SWATCH](state, payload) {
    const found = state.swatches.find((s: ISwatch) => s.swatchId === payload.swatchId && s.color === payload.color);
    if (!found) state.swatches = [ ...state.swatches, payload ];
  },
  [MutationTypesPickYourOwnColor.SET_IS_REMOVING](state, payload) {
    state.isRemoving = payload;
  },
  [MutationTypesPickYourOwnColor.REMOVE_SWATCH](state, payload) {
    const foundIndex = state.swatches.findIndex((item: ISwatch) => payload.swatchId === item.swatchId && payload.color === item.color);
    state.swatches.splice(foundIndex, 1);
  },
};

export default mutations;
